// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ghost--option[data-v-f6b6fe70] {\n  opacity: 0.5;\n  background-color: #f8f9fa;\n  border: dashed 1px #ccc;\n}\n.table__option--block td[data-v-f6b6fe70] {\n  padding: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
